import React from "react";

const Context = React.createContext<{
  gutters: { id: string; ref: React.MutableRefObject<HTMLDivElement | null> }[];
  subscribers: {
    id: string;
    ref: React.MutableRefObject<HTMLDivElement | null>;
  }[];
  getGutters(): {
    id: string;
    ref: React.MutableRefObject<HTMLDivElement | null>;
  }[];
  registerGutter(gutter: {
    id: string;
    ref: React.MutableRefObject<HTMLDivElement | null>;
  }): void;
  removeGutter(id: string): void;
  registerSubscriber(subscriber: {
    id: string;
    ref: React.MutableRefObject<HTMLDivElement | null>;
  }): void;
  removeSubscriber(subscriber: {
    id: string;
    ref: React.MutableRefObject<HTMLDivElement | null>;
  }): void;
}>({
  gutters: [],
  subscribers: [],
  getGutters: () => [],
  registerGutter: () => {},
  removeGutter: () => {},
  registerSubscriber: () => {},
  removeSubscriber: () => {},
});

export { Context };
